import { render } from "./tab-consultation-reason.vue?vue&type=template&id=b8ca9888&scoped=true"
import script from "./tab-consultation-reason.vue?vue&type=script&lang=js"
export * from "./tab-consultation-reason.vue?vue&type=script&lang=js"

import "./tab-consultation-reason.vue?vue&type=style&index=0&id=b8ca9888&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8ca9888"]])

export default __exports__